// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".worksheets-panel-container {\n  display: flex;\n  flex-direction: column;\n  width: 250px;\n}\n", "",{"version":3,"sources":["webpack://src/modules/accounting_statement_app/components/WorksheetsPanel/WorksheetsPanel.less"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd","sourcesContent":[".worksheets-panel-container {\n  display: flex;\n  flex-direction: column;\n  width: 250px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
